import {
  FileText,
  ShieldCheck,
  TrendingUp,
  RefreshCw,
  GraduationCap,
  HandCoins,
  Briefcase,
  HeartPulse,
  Landmark,
} from "lucide-react";

export const SERVICES = [
  {
    id: "tax-prep",
    title: "Tax Preparation & Strategy",
    tag: "Featured",
    category: "Tax & Retirement",
    description:
      "Comprehensive individual and business tax filing — in proud partnership with TrueFile Tax Co — engineered to maximize deductions, ensure compliance, and minimize liability.",
    highlight: "Proactive 365 Tax Optimization",
    icon: FileText,
  },
  {
    id: "life-insurance",
    title: "Life Insurance & Wealth Transfer",
    tag: "Protection",
    category: "Protection & Legacy",
    description:
      "Custom term, whole, and IUL policies structured to safeguard family income and build tax-advantaged cash value.",
    highlight: "Tax-Free Living Benefits",
    icon: ShieldCheck,
  },
  {
    id: "retirement",
    title: "Tax-Efficient Retirement Planning",
    tag: "Wealth Growth",
    category: "Tax & Retirement",
    description:
      "Strategic distribution planning designed to minimize retirement income taxes and eliminate longevity risk.",
    highlight: "Zero-Tax Retirement Buckets",
    icon: TrendingUp,
  },
  {
    id: "rollovers",
    title: "401(k) & IRA Rollovers",
    tag: "Allocation",
    category: "Tax & Retirement",
    description:
      "Seamless consolidation of old employer plans into self-directed IRAs with principal protection and growth potential.",
    highlight: "Zero-Penalty Rollover Execution",
    icon: RefreshCw,
  },
  {
    id: "college",
    title: "Million Dollar Baby Fund",
    tag: "Generational",
    category: "Protection & Legacy",
    description:
      "Tax-advantaged education funds structured to finance higher education without draining legacy wealth.",
    highlight: "Structured Education Assets",
    icon: GraduationCap,
  },
  {
    id: "debt",
    title: "Debt Relief & Restructuring",
    tag: "Freedom",
    category: "Protection & Legacy",
    description:
      "Strategic debt elimination frameworks that accelerate payoff and redirect cash flow into legacy investments.",
    highlight: "Accelerated Debt Elimination",
    icon: HandCoins,
  },
  {
    id: "business",
    title: "Business Financial Solutions",
    tag: "Corporate",
    category: "Business",
    description:
      "Executive compensation, key-person insurance, employee benefits, and tax-deferred business retirement strategies.",
    highlight: "Corporate Asset & Tax Protection",
    icon: Briefcase,
  },
  {
    id: "long-term-care",
    title: "Long-Term Care Protection",
    tag: "Risk",
    category: "Protection & Legacy",
    description:
      "Asset-based long-term care solutions protecting portfolio capital from catastrophic care expenses.",
    highlight: "Preserve Portfolio Longevity",
    icon: HeartPulse,
  },
  {
    id: "estate",
    title: "Trust & Will Estate Planning",
    tag: "Legacy",
    category: "Protection & Legacy",
    description:
      "Comprehensive trust and estate structures ensuring seamless, probate-free asset transfer to your beneficiaries.",
    highlight: "Probate-Free Heritage Transfer",
    icon: Landmark,
  },
];

export const CATEGORIES = ["All", "Tax & Retirement", "Protection & Legacy", "Business"];
